import { createFileRoute } from '@tanstack/react-router'
import { CreateBotOnboarding } from '~/features/bots/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/new-bot')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botId } = Route.useParams()

  return <CreateBotOnboarding botId={botId} workspaceId={workspaceId} />
}
